import React from "react";

const Frontend = () => {
  return (
    <div className="skills__content flex flex-col gap-5">
      <h3 className="skills__title ">Frontend</h3>

      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <i class="bx bxl-react"></i>
            <div>
              <h3 className="skills__name">React</h3>
            </div>
          </div>

          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Next.js</h3>
            </div>
          </div>

          <div className="skills__data">
            <i class="bx bxl-typescript"></i>
            <div>
              <h3 className="skills__name">TypeScript</h3>
            </div>
          </div>

          <div className="skills__data">
            <i class="bx bxl-javascript"></i>
            <div>
              <h3 className="skills__name">JavaScript</h3>
            </div>
          </div>

          <div className="skills__data">
            <i class="bx bxl-tailwind-css"></i>
            <div>
              <h3 className="skills__name">Tailwind CSS</h3>
            </div>
          </div>
        </div>

        <div className="skills__group">
          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">shadcn/ui</h3>
            </div>
          </div>

          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">TanStack Query</h3>
            </div>
          </div>

          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">React Hook Form + Zod</h3>
            </div>
          </div>

          <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
              <h3 className="skills__name">Zustand</h3>
            </div>
          </div>

          <div className="skills__data">
            <i class="bx bxl-react"></i>
            <div>
              <h3 className="skills__name">React Native</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Frontend;
